import React from 'react';
import PropTypes from 'prop-types';

const SortableTh = ({
    children,
    content,
    sort,
    sortName,
    hide,
    width,
    ...passThroughProps
}) => {
    const sortClass = sortName ? (sort.sortColumn === sortName ?
            (sort.sortDesc ? 'sort-desc' : 'sort-asc') : '') : '';

    const displayClasses = hide ? `d-none d-${hide}-table-cell` : '';

    const widthStyle = width ? { width: width } : {}

    const handleClick = sortName !== undefined
        ? () => sort.setSort(sortName)
        : () => { };

    return (
        <th
            {...passThroughProps}
            className={`${passThroughProps.className || ''} ${displayClasses} sortable`}
            onClick={handleClick}
            style={{ ...passThroughProps.style, ...widthStyle }}
        >
            <span className={sortClass}>
                {content}
                {children}
            </span>
        </th>
    );
}

SortableTh.propTypes = {
    content: PropTypes.string,
    sort: PropTypes.object,
    hide: PropTypes.string,
    sortName: PropTypes.string
};

export default SortableTh;